import React from 'react';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';

export default function SaleAccountAlertWarningModal({
	isOpenModal,
	setIsOpenModal,
	cancelAccountSelect,
}) {
	return (
		<Modal
			className={'confirmatinBoxModal'}
			title="Confirm Sales Account Selection"
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div
				style={{
					textAlign: 'center',
					backgroundColor: '#E6F5FF',
					padding: '20px 10px',
					marginBottom: '20px',
					borderRadius: '5px',
					fontWeight: '600',
					color: 'black',
				}}
			>
				You have selected an account that is not an Income account. Sales invoices are usually
				recorded under a Sales or Income account. Selecting this account may affect your accounting
				reports.
			</div>
			<div className="d-flex justify-content-end align-items-center gap-4">
				<Button
					type="button"
					button={'Cancel'}
					className="mt-0 px-4 btn-secondary relative"
					onClick={() => cancelAccountSelect()}
				/>
				<Button
					type="button"
					button={'Confirm'}
					className="mt-0 px-5 btn-primary relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
			</div>
		</Modal>
	);
}
